export default {
  // Text relating to the future
  coming_soon: "Coming Soon...",

  // Text for getGreeting function
  good_morning: "Good Morning",
  good_day: "Good Day",
  good_afternoon: "Good Afternoon",
  good_evening: "Good Evening",

  // Text for getTemporalInfo function
  minute_ago: " minute ago",
  minutes_ago: " minutes ago",
  hour_ago: " hour ago",
  hours_ago: " hours ago",
  day_ago: " day ago",
  days_ago: " days ago",
  day: " day",
  days: " days",
  today: "Today",
  in_x_weeks: "next week | in {weeks} weeks",
  x_weeks_ago: "last week | {weeks} weeks ago",
  in: "In ",
  was_date: "was {date}",
  deadline: "Deadline",
  latest_raised: "Latest raised ",
  next_deadline: "Next deadline ",
  last_deadline: "Last deadline ",

  // Text for timeRequirement function
  day_with_placeholder: "{day} day",
  days_with_placeholder: "{day} days",
  days_and_hours: "{day} days and {hour} hours",
  days_and_hour: "{day} days and {hour} hour",
  day_and_hours: "{day} day and {hour} hours",
  day_and_hour: "{day} day and {hour} hour",
  hour_with_placeholder: "{hour} hour",
  hours_with_placeholder: "{hour} hours",
  hours_and_minutes: "{hour} hours and {minute} minutes",
  hours_and_minute: "{hour} hours and {minute} minute",
  hour_and_minutes: "{hour} hour and {minute} minutes",
  hour_and_minute: "{hour} hour and {minute} minute",
  minute_with_placeholder: "{minute} minute",
  minutes_with_placeholder: "{minute} minutes",
  less_than_a_minute: "Less than a minute",

  // Text for data point deadline
  issue_overdue_by_soon: "Overdue by less than a day",
  issue_overdue_in_24: "In less than 24 hours",
  issue_overdue_by_day_one: "Overdue by 1 day",
  issue_overdue_by_day_multiple: "Overdue by {days} days",
  issue_deadline_in_day_one: "In 1 day",
  issue_deadline_in_day_multiple: "In {days} days",
  issue_deadline_in_week: "In 1 week",

  hours_minutes: "{hour} hours {minute} minutes",
  hours_minute: "{hour} hours 1 minute",
  hour_minutes: "1 hour {minute} minutes",
  hour_minute: "1 hour 1 minute",

  generic_overdue: "Overdue",
  generic_behind: "Behind",

  not_applicable: "N/A",
}
